import { useNavigate } from "react-router-dom";
import { TbFaceIdError } from "react-icons/tb";

export default function ServerError() {
    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate(-1); // Goes back one page
    };

    return (
        <div className="flex flex-col justify-center items-center min-h-screen gap-6 bg-white">
            <TbFaceIdError size={120} className="text-red-500" />
            <div className="text-center text-black">
                <p className="text-3xl font-bold">Oops!</p>
                <p className="text-xl">Something went wrong</p>
                <p className="text-lg">Please try again later</p>
                <button
                    className="text-lg py-3 px-8 text-white bg-blue-500 rounded-full cursor-pointer mt-4 hover:bg-blue-600 transition"
                    onClick={handleRedirect}
                >
                    Reload
                </button>
            </div>
        </div>
    );
}
